'use client';

import { Flex, Modal, ScrollArea, Text } from '@mantine/core';

import { NliDarkOutlinedButton, NliOutlinedButton } from '@repo/ui/components/nli-button';
import styles from './NliAnnouncementModal.module.css';

const NliAnnouncementModalComponent = ({
    opened,
    onClose,
    announcement,
    title,
    closeButtonText,
    dontShowAgainText
}: {
    opened:boolean;
    announcement: {
        _id: string;
        title: string;
        message: string;
        imagePath?: string;
        buttonText?: string;
        buttonLink?: string;
    };
    title:string;
    closeButtonText:string;
    dontShowAgainText:string;
    onClose?: (hasSeen: boolean) => void
}) => {
    const handleClose = (seen:boolean) => () => {
        onClose?.(seen)
    }

    return (
        <Modal
            opened={opened}
            onClose={handleClose(false)}
            title={title}
            size="xl"
            scrollAreaComponent={ScrollArea.Autosize}
            centered
            zIndex={999999}
        >
            <Flex align="flex-start" gap="md" p="xs">
                { announcement.imagePath && <img src={`${process.env.NEXT_PUBLIC_API_URL}/${announcement.imagePath}`} alt={announcement._id} style={{ maxWidth: '200px' }} /> }
                <Flex direction="column" gap="md">
                    <Text size="lg" fw={700}>
                        {announcement.title}
                    </Text>
                    {/* 
                  Security note: announcement.message is generated by the RichTextEditor (TipTap)
                  in the BO admin panel. TipTap only produces safe HTML with configured extensions
                  (no script tags, no event handlers). This is admin-controlled content, not user input.
                  The dangerouslySetInnerHTML is acceptable here due to the trusted source.
                */}
                    <div className={styles.content} dangerouslySetInnerHTML={{ __html: announcement.message }} />
                </Flex>
            </Flex>
            <Flex
                justify="center"
                gap="md"
                py="xs"
                bg="var(--color-background-light)"
            >
                <NliOutlinedButton aria-label={closeButtonText} onClick={handleClose(true)}>
                    {dontShowAgainText}
                </NliOutlinedButton>
                {
                    announcement.buttonText && announcement.buttonLink && (
                        <NliDarkOutlinedButton
                            component="a"
                            href={announcement.buttonLink}
                            target="_blank"
                            aria-label={announcement.buttonText}
                        >
                            {announcement.buttonText}
                        </NliDarkOutlinedButton>
                    )
                }
            </Flex>
        </Modal>
    )
}

export default NliAnnouncementModalComponent